import {
  convertSerializableEntryInfo,
  SerializableInspectionMediaEntry
} from '../../models/SerializableSdkTypes/SerializableDviTypes'
import { InspectionMediaEntry } from '../../sdk'
import { ReplicacheInstance } from '..'
import { getDviImageCacheURL, MediaCacheName } from '.'

export async function addNewInspectionMedia(
  blob: Blob,
  entry: InspectionMediaEntry,
  inspectionId: string,
  rep: ReplicacheInstance | undefined
) {
  if (!rep) {
    return
  }
  await addNewMediaToCacheStorage(blob, entry)
  await addNewMediaToReplicache(entry, inspectionId, rep)
  // not upload to backend here, updating replicache will trigger global subscription to run syncMediaOfInspectionWithBackend
}

async function addNewMediaToCacheStorage(
  blob: Blob,
  entry: InspectionMediaEntry
) {
  // add it to cache
  const cache = await caches.open(MediaCacheName)
  const cacheUrl = getDviImageCacheURL(entry.id!)
  await cache.put(cacheUrl, new Response(blob))
}
async function addNewMediaToReplicache(
  entry: InspectionMediaEntry,
  inspectionId: string,
  rep: ReplicacheInstance
) {
  // update replicache with uuid and no url
  const updatedEntry: SerializableInspectionMediaEntry = {
    id: entry.id!,
    info: convertSerializableEntryInfo({ ...entry.info! }),
    mediaUrl: null,
    thumbnailUrl: null
  }
  await rep.mutate.addInspectionMedia({
    inspection: inspectionId,
    media: updatedEntry
  })
}
